export const DemandProductCategory = {
    CYLINDER_OIL: 'CYLINDER_OIL',
    // Mirrors the misspelling in the backend API contract.
    SYSMTEM_OIL_2_STROKE: 'SYSMTEM_OIL_2_STROKE',
    ENGINE_OIL_4_STROKE: 'ENGINE_OIL_4_STROKE',
    ANCILLARY_OIL: 'ANCILLARY_OIL',
    GREASE: 'GREASE',
    BLEND_ON_BOARD_ADDITIVES: 'BLEND_ON_BOARD_ADDITIVES',
} as const;

// eslint-disable-next-line no-redeclare
export type DemandProductCategory = (typeof DemandProductCategory)[keyof typeof DemandProductCategory];
